import React from "react";
import Overlay from "react-bootstrap/Overlay";

const PopupMessage = (props) => {
  const { target, show, message } = props;
  return (
    <Overlay target={target.current} show={show} placement="bottom">
      {({ placement, arrowProps, show: _show, popper, ...props }) => (
        <div
          role="alert"
          aria-relevant="all"
          {...props}
          style={{
            backgroundColor: "#dd000d",
            padding: "2px 10px",
            color: "white",
            borderRadius: "0.5rem",
            ...props.style,
          }}
        >
          {message}
        </div>
      )}
    </Overlay>
  );
};

export default PopupMessage;
